import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import { isEmpty } from 'lodash';
import moment from 'moment';
let default_1 = class default_1 extends Vue {
    effectivePeriod;
    effectiveDates;
    effectiveTimes;
    dayOfWeeks;
    disabled;
    everyDay = ['DAILY'];
    wholeWeek = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];
    allDay = [...this.everyDay, ...this.wholeWeek];
    days = [
        { label: this.$t('day1'), value: 'MONDAY' },
        { label: this.$t('day2'), value: 'TUESDAY' },
        { label: this.$t('day3'), value: 'WEDNESDAY' },
        { label: this.$t('day4'), value: 'THURSDAY' },
        { label: this.$t('day5'), value: 'FRIDAY' },
        { label: this.$t('day6'), value: 'SATURDAY' },
        { label: this.$t('day7'), value: 'SUNDAY' },
    ];
    isAlways = this.$props.effectivePeriod === 'PERMANENT';
    checkAll = false;
    timeList = [{ start: '', end: '', effectiveTimes: ['00:00:00', '23:59:59'] }];
    maxNum = 3;
    minNum = 1;
    times = [];
    formData = {
        effectivePeriod: 'PERMANENT',
        effectiveDates: [],
        effectiveTimes: [{ effectiveTimes: [] }],
        dayOfWeeks: [],
    };
    get dateOptions() {
        return {
            disabledDate: (date) => moment(date).isBefore(moment().format('YYYY-MM-DD')),
        };
    }
    get rules() {
        if (!this.isAlways) {
            return {
                effectiveDates: [
                    { required: true, message: this.$t('dateRule'), trigger: 'change' },
                    {
                        validator: (rule, value, callback) => {
                            if (isEmpty(value[0]) || isEmpty(value[1])) {
                                callback(new Error(this.$t('dateRule')));
                            }
                            else {
                                callback();
                            }
                        },
                        trigger: 'change',
                    },
                ],
                effectiveTimes: [
                    { required: true, message: this.$t('timeRule'), trigger: 'change' },
                    {
                        validator: (rule, value, callback) => {
                            const ret = value.find((item) => {
                                return !item.effectiveTimes;
                            });
                            if (ret) {
                                callback(new Error(this.$t('timeRule')));
                            }
                            else {
                                callback();
                            }
                        },
                        trigger: 'change',
                    },
                ],
                dayOfWeeks: [{ required: true, message: this.$t('dayRule'), trigger: 'change' }],
            };
        }
        else {
            return {
                effectiveDates: [{ required: false, message: this.$t('dateRule'), trigger: 'change' }],
                effectiveTimes: [{ required: false, message: this.$t('timeRule'), trigger: 'change' }],
                dayOfWeeks: [{ required: false, message: this.$t('dayRule'), trigger: 'change' }],
            };
        }
    }
    mounted() {
        this.formData = {
            effectivePeriod: this.effectivePeriod,
            effectiveDates: [this.effectiveDates.start, this.effectiveDates.end],
            effectiveTimes: this.effectiveTimes,
            dayOfWeeks: this.dayOfWeeks?.includes('DAILY') ? this.wholeWeek : this.dayOfWeeks,
        };
        const checked = this.dayOfWeeks;
        if (checked?.includes('DAILY')) {
            this.checkAll = true;
        }
        else {
            this.checkAll = false;
        }
    }
    periodChange(val) {
        this.isAlways = val === 'PERMANENT';
        if (this.isAlways) {
            this.formData = {
                effectivePeriod: 'PERMANENT',
                effectiveDates: [],
                effectiveTimes: [{ effectiveTimes: [] }],
                dayOfWeeks: [],
            };
            this.dateChange([]);
            this.timeChange([], 0);
            this.daysChange([]);
            this.checkAll = false;
        }
        else {
            this.formData.effectiveTimes = [{ effectiveTimes: ['00:00:00', '23:59:59'] }];
            this.timeChange(this.formData.effectiveTimes, 0);
        }
        this.$emit('update:effectivePeriod', val);
    }
    dateChange(date) {
        this.$emit('update:effectiveDates', { start: date[0], end: date[1] });
    }
    timeChange(time, index) {
        this.$emit('update:effectiveTimes', time);
    }
    daysChange(days) {
        let checkedCount = days.length;
        this.checkAll = checkedCount === this.wholeWeek.length;
        if (this.checkAll) {
            this.$emit('update:dayOfWeeks', this.allDay);
        }
        else {
            this.$emit('update:dayOfWeeks', this.formData.dayOfWeeks);
        }
    }
    handleCheckAllChange(val) {
        this.formData.dayOfWeeks = val ? this.wholeWeek : [];
        if (val) {
            this.$emit('update:dayOfWeeks', this.allDay);
        }
        else {
            this.$emit('update:dayOfWeeks', this.formData.dayOfWeeks);
        }
    }
    isValidate() {
        let isValidate = null;
        this.$refs.ruleForm.validate((valid) => {
            if (valid) {
                isValidate = true;
            }
            else {
                isValidate = false;
            }
        });
        return isValidate;
    }
    addTime() {
        if (this.formData.effectiveTimes.length === this.maxNum) {
            return;
        }
        this.formData.effectiveTimes.push({ start: '', end: '' });
    }
    removeDomain(item) {
        if (this.formData.effectiveTimes.length === this.minNum) {
            return;
        }
        const index = this.formData.effectiveTimes.indexOf(item);
        if (index !== -1) {
            this.formData.effectiveTimes.splice(index, 1);
        }
        this.timeChange(this.formData.effectiveTimes, index);
    }
};
__decorate([
    Prop()
], default_1.prototype, "effectivePeriod", void 0);
__decorate([
    Prop()
], default_1.prototype, "effectiveDates", void 0);
__decorate([
    Prop()
], default_1.prototype, "effectiveTimes", void 0);
__decorate([
    Prop()
], default_1.prototype, "dayOfWeeks", void 0);
__decorate([
    Prop({ default: false, type: Boolean })
], default_1.prototype, "disabled", void 0);
default_1 = __decorate([
    Component({
        name: 'ValidTime',
        components: {},
        i18n: {
            messages: {
                zh: {
                    title: '生效时间',
                    always: '永久生效',
                    custom: '自定义',
                    date: '时间段',
                    time: '详细时间',
                    frequency: '重复日期',
                    day0: '每日',
                    day1: '每周一',
                    day2: '每周二',
                    day3: '每周三',
                    day4: '每周四',
                    day5: '每周五',
                    day6: '每周六',
                    day7: '每周日',
                    placeholder: '请选择',
                    allDay: '全天',
                    dateRule: '请选择日期',
                    timeRule: '请选择时间',
                    dayRule: '请选择重复日期',
                    startDate: '开始',
                    endDate: '结束',
                    add: '添加',
                    repetitionTime: '所选时间重复，请重新选择！',
                },
                en: {
                    title: 'Valid Time',
                    always: 'Always',
                    custom: 'Customised date range',
                    date: 'Date',
                    time: 'Time',
                    frequency: 'Frequency',
                    day0: 'Every',
                    day1: 'Mon',
                    day2: 'Tue',
                    day3: 'Wed',
                    day4: 'Thur',
                    day5: 'Fri',
                    day6: 'Sat',
                    day7: 'Sun',
                    placeholder: 'Please select',
                    allDay: 'All day',
                    dateRule: 'Please select date',
                    timeRule: 'Please select time',
                    dayRule: 'Please select frequency',
                    startDate: 'Start',
                    endDate: 'End',
                    add: 'add',
                    repetitionTime: 'Time periods repeat, please select again!',
                },
            },
        },
    })
], default_1);
export default default_1;
